import { createFileRoute } from '@tanstack/react-router'

import { TheCargoMailPage } from '#/modules/thecargo-mail/mail-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/thecargo-mail')({
  component: TheCargoMailPage,
  validateSearch: validateListSearch,
})
